import { render, staticRenderFns } from "./SurveyConfig.vue?vue&type=template&id=7008cc60&scoped=true"
import script from "./SurveyConfig.vue?vue&type=script&lang=js"
export * from "./SurveyConfig.vue?vue&type=script&lang=js"
import style0 from "./SurveyConfig.vue?vue&type=style&index=0&id=7008cc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008cc60",
  null
  
)

export default component.exports